import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 搜索页
 * @author Spark
 */
import api from 'api/category';
import { mapGetters } from 'vuex';
import { GET_PLUS_SDK } from '$getters';
export default {
  name: 'page-search',
  data: function data() {
    return {
      searchValue: null,
      showGoodsTemplatePicker: false,
      selectGoodsTemplateIndex: 0,
      goodsTemplates: [],
      searchHistory: [],
      fromGoodsTemplate: null,
      fromGoodsSearchTemplateIdList: null,
      fromPath: null,
      defaultIndex: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    plusSdk: GET_PLUS_SDK
  })), {}, {
    // 商品大类名称集合
    goodsTemplateNames: function goodsTemplateNames() {
      return this.goodsTemplates.map(function (tem) {
        return tem.templateIdName;
      });
    },
    currentGoodsTemplate: function currentGoodsTemplate() {
      return this.goodsTemplates[this.selectGoodsTemplateIndex];
    }
  }),
  methods: {
    back: function back() {
      // console.log(this.fromPath,"返回上一级",this.currentGoodsTemplate.templateId)
      if (this.fromPath == '/goodsList') {
        this.$router.push('/goodsList?templateId=' + this.currentGoodsTemplate.templateId);
      } else {
        this.$router.go(-1);
      }
    },
    findGoodsTemplate: function findGoodsTemplate() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        api.selectGoodsTemplateInfo().then(function (res) {
          _this.goodsTemplates = res.data;

          if (_this.fromGoodsTemplate === 1) {
            _this.defaultIndex = 0;
          } else if (_this.fromGoodsTemplate === 2) {
            _this.defaultIndex = 1;
          } else {
            _this.defaultIndex = 2;
          }

          resolve();
        }).catch(function () {
          // eslint-disable-next-line
          reject();
        });
      });
    },
    onChange: function onChange(picker, value, index) {
      var vm = this;
      vm.selectGoodsTemplateIndex = index;
      vm.showGoodsTemplatePicker = false;
    },
    onGoodsTemplateConfirm: function onGoodsTemplateConfirm(value, index) {
      this.selectGoodsTemplateIndex = index;
      this.showGoodsTemplatePicker = false;
    },
    handleClickHistory: function handleClickHistory(tag, index) {
      var _this2 = this;

      this.goodsTemplates.forEach(function (template, index) {
        if (template.templateId === parseInt(tag.goodsTemplate.templateId)) {
          _this2.selectGoodsTemplateIndex = index;
          return null;
        }
      });
      this.searchValue = tag.search;
    },
    pushCache: function pushCache() {
      var lastCache = this.searchHistory[this.searchHistory.length - 1];

      if (lastCache != null && this.searchValue === lastCache.search && this.currentGoodsTemplate.templateId === lastCache.goodsTemplate.templateId) {
        return;
      }

      if (this.searchHistory.length > 20) {
        this.searchHistory.splice(0, 1);
      }

      this.searchHistory.push({
        goodsTemplate: this.currentGoodsTemplate,
        search: this.searchValue
      });
      this.$pushCache('search-history', this.searchHistory, 30 * 24 * 3600);
    },
    search: function search() {
      //友盟统计
      var _window = window,
          aplus_queue = _window.aplus_queue;
      console.log("=========", aplus_queue);
      aplus_queue.push({
        action: 'aplus.sendPV',
        arguments: [{
          is_auto: false
        }]
      });

      if (this.searchValue != null && this.searchValue.length > 0) {
        this.searchValue = this.searchValue.trim();

        if (this.searchValue.length > 0) {
          this.pushCache();
        }
      }

      if (this.fromPath.indexOf('exhibition') > -1) {
        this.$router.push({
          path: this.fromPath + "?templateId=" + this.currentGoodsTemplate.templateId,
          query: _defineProperty({
            goodsSearchTemplateIdList: 256,
            keyword: this.searchValue
          }, "goodsSearchTemplateIdList", this.fromGoodsSearchTemplateIdList)
        });
      } else {
        this.$router.push({
          name: 'goodsList',
          params: {
            templateId: this.currentGoodsTemplate.templateId,
            keyword: this.searchValue
          }
        });
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fromPath = from.path;
      var promise = vm.findGoodsTemplate();

      if (from.query['templateId'] != null || from.params['templateId'] != null) {
        var searchHistory = {
          goodsTemplate: {},
          search: null
        };
        vm.fromGoodsTemplate = from.query['templateId'];
        vm.fromGoodsSearchTemplateIdList = from.query['goodsSearchTemplateIdList'];
        searchHistory.goodsTemplate['templateId'] = from.query['templateId'] != null ? from.query['templateId'] : from.params['templateId'] != null;

        if (from.params['keyword']) {
          searchHistory['search'] = from.params['keyword'];
        }

        promise.then(function () {
          vm.handleClickHistory(searchHistory);
        });
      } // let searchHistory = vm.$getCache('search-history')
      // if (searchHistory != null && searchHistory.length > 0) {
      //   vm.searchHistory = searchHistory
      //   if (from.params['searchValue'] != null) {
      //     promise.then(() => {
      //       vm.handleClickHistory(vm.searchHistory[vm.searchHistory.length - 1], vm.searchHistory.length - 1)
      //     })
      //   }
      // }

    });
  },
  mounted: function mounted() {}
};